import { __ } from '@wordpress/i18n';
import { RawHTML, useEffect } from "@wordpress/element";
import { useBlockProps, InnerBlocks, InspectorControls, ColorPalette } from '@wordpress/block-editor';
import { __experimentalHeading as Heading, PanelBody, __experimentalUnitControl as UnitControl, __experimentalNumberControl as NumberControl } from '@wordpress/components';

export const edit = ({ clientId, attributes, setAttributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuLinkSize,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuLinkCurrentColor,
        megaMenuLinksHoverColor,
        megaMenuLinksHoverBGColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuBtncolor,
        megaMenuBtnHovercolor,
        megaMenuBorderColor,
        megaMenuCardImageHeight,
    } = attributes;

    useEffect(() => {
        if (!id) {
            // Set unique ID through block index only once.
            let clientIdSliced = clientId.slice(clientId.lastIndexOf("-") + 1);
            setAttributes({ id: 'hfcmm-' + clientIdSliced });
        }
    }, [id, clientId, setAttributes]);

    // Defined Block Props.
    const blockProps = useBlockProps();

    const ALLOWED_BLOCKS = [
        'core/group',
        'core/columns',
        'core/column',
        'core/list',
        'core/list-item',
        'core/image',
        'core/heading',
        'core/paragraph'
    ];

    const TEMPLATE = [['core/group', {
        className: 'hfc-mm-1'
    }, [
        ['core/columns', {
            verticalAlignment: 'center',
            className: 'hfc-mm-cols'
        }, [
            ['core/column', {
                width: '25%',
                className: 'hfc-mm-col'
            }, [
                ['core/list', {
                    className: 'hfc-mm-list'
                }, [
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Lorem ipsum dolor sit</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Adipiscing elit hendrerit augue</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Aliquet in dictum scelerisque</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Ornare sociis massa vitae</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Proin tortor purus nostra</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Ornare sociis massa vitae</a>',
                    }],
                    ['core/list-item', {
                        content: '<a href="#" rel="nofollow">Proin tortor purus nostra</a>',
                    }]
                ]]
            ]],
            ['core/column', {
                width: '25%',
                className: 'hfc-mm-col'
            }, [
                ['core/image', {
                    url: require('../../public/img/hfc-footer-background.jpg'),
                    align: 'center'
                }],
                ['core/heading', {
                    level: 4,
                    content: 'Lorem ipsum dolor'
                }],
                ['core/paragraph', {
                    content: 'Lorem ipsum dolor sit amet consectetur adipiscing elit, lectus nullam dictum neque integer etiam semper aenean, montes vel himenaeos sociis dapibus erat in facilisis turpis arcu habitasse.'
                }],
                ['core/paragraph', {
                    content: '<a href="#">See more →</a>',
                    className: 'hfc-mm-col-link'
                }]
            ]],
            ['core/column', {
                width: '25%',
                className: 'hfc-mm-col'
            }, [
                ['core/image', {
                    url: require('../../public/img/hfc-footer-background.jpg'),
                    align: 'center'
                }],
                ['core/heading', {
                    level: 4,
                    content: 'Lorem ipsum dolor'
                }],
                ['core/paragraph', {
                    content: 'Lorem ipsum dolor sit amet consectetur adipiscing elit, lectus nullam dictum neque integer etiam semper aenean, montes vel himenaeos sociis dapibus erat in facilisis turpis arcu habitasse.'
                }],
                ['core/paragraph', {
                    content: '<a href="#">See more →</a>',
                    className: 'hfc-mm-col-link'
                }]
            ]],
            ['core/column', {
                width: '25%',
                className: 'hfc-mm-col'
            }, [
                ['core/image', {
                    url: require('../../public/img/hfc-footer-background.jpg'),
                    align: 'center'
                }],
                ['core/heading', {
                    level: 4,
                    content: 'Lorem ipsum dolor'
                }],
                ['core/paragraph', {
                    content: 'Lorem ipsum dolor sit amet consectetur adipiscing elit, lectus nullam dictum neque integer etiam semper aenean, montes vel himenaeos sociis dapibus erat in facilisis turpis arcu habitasse.'
                }],
                ['core/paragraph', {
                    content: '<a href="#">See more →</a>',
                    className: 'hfc-mm-col-link'
                }]
            ]]
        ]]
    ]]];

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu .hfc-mm-1{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        border-top: 5px solid ${megaMenuBorderColor};
        width: ${megaMenuInnerWidth};
        margin: 0px auto!important;
    }
   .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label,
   .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style: solid;
        border-color: ${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item:nth-child(${menuItemNum}) .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    #${id} ul.hfc-mm-list li a {
        padding: 10px calc(${megaMenuPadding}px - 10px);
        display: block;
        border-bottom: 1px dotted ${megaMenuBorderColor};
        padding-left: 0;
        transition: .3s;
        text-decoration: none!important;
        color: ${megaMenuLinkCurrentColor};
    }
    #${id} ul.hfc-mm-list li a:hover {
        background: ${megaMenuLinksHoverBGColor};
        padding-left: 10px;
        color: ${megaMenuLinksHoverColor};
        border: 0;
    }
    #${id} .hfc-mm-col .wp-block-image img {
        display: block;
        height: ${megaMenuCardImageHeight};
        object-fit: cover;
        margin-bottom: 4px;
    }
    #${id} .hfc-mm-col h4.wp-block-heading {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 4px!important;
    }
    #${id} .hfc-mm-col p {
        font-size: 14px;
        margin-bottom: 4px!important;
        line-height: 20px;
        color: #000!important;
        font-weight: normal;
    }
    #${id} .wp-block-columns.hfc-mm-cols {
        gap: 10px;
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col ul{
        list-style: none;
        margin: 0px;
    }
    #${id} ul.hfc-mm-list li{
        font-size: ${megaMenuLinkSize};
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col .hfc-mm-col-link a{
        text-decoration: none;
        color: ${megaMenuBtncolor};
        transition: 0.3s;
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col .hfc-mm-col-link a:hover{
        color: ${megaMenuBtnHovercolor};
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col:first-child {
        padding-right: ${megaMenuPadding}px;
    }
    #${id} .hfc-mm-1 .wp-block-columns.hfc-mm-cols .wp-block-column.hfc-mm-col:not(:first-of-type) {
        border: 1px solid ${megaMenuBorderColor};
        padding: 5px;
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col > .wp-block{
        margin: 0px;
    }
    /* Edit Page Compatibility */
    .editor-styles-wrapper .wp-block-hfc-blocks-mega-menu-1,
    .editor-styles-wrapper .hfc-mm-1,
    .editor-styles-wrapper .hfc-mm-cols,
    .editor-styles-wrapper .hfc-mega-menu .wp-block-group__inner-container {
        max-width: 1200px !important;
        margin: auto;
    }
    .editor-styles-wrapper .wp-block-columns.hfc-mm-cols .hfc-mm-col ul,
    .editor-styles-wrapper .hfc-mega-menu .block-editor-block-list__layout{
       padding: 0px;
    }`;

    return ([
        <InspectorControls key={`inspector-controls-${id}`}>
            <PanelBody
                title={__('Cross Rating Block Settings')}
                icon={'admin-generic'}
                initialOpen={true}
                className={'frhd__control frhd__control-query'}
                >
                <NumberControl
                    label={__('Menu Item Number')}
                    isShiftStepEnabled={ true }
                    onChange={newValue => setAttributes({ menuItemNum: newValue })}
                    shiftStep={ 1 }
                    value={ menuItemNum }
                    />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Padding (px) :</Heading>
                <NumberControl
                    onChange={(newValue) => setAttributes({ megaMenuPadding: newValue })}
                    isDragEnabled
                    value={megaMenuPadding}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Mega Menu Link Font Size :')}
                    onChange={newValue => setAttributes({ megaMenuLinkSize: newValue })}
                    isUnitSelectTabbable
                    value={megaMenuLinkSize}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Mega Menu Inner Width :')}
                    onChange={newValue => setAttributes({ megaMenuInnerWidth: newValue })}
                    isUnitSelectTabbable
                    value={megaMenuInnerWidth}
                    className={'frhd__component frhd__component-width-90'}
                />
                <UnitControl
                    label={__('Mega Menu Image Height :')}
                    onChange={newValue => setAttributes({ megaMenuCardImageHeight: newValue })}
                    isUnitSelectTabbable
                    value={megaMenuCardImageHeight}
                    className={'frhd__component frhd__component-width-90'}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Background Color :</Heading>
                <ColorPalette
                    value={megaMenuBGcolor}
                    onChange={(colorValue) => setAttributes({ megaMenuBGcolor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Links Color :</Heading>
                <ColorPalette
                    value={megaMenuLinkCurrentColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinkCurrentColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu Links Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuLinksHoverColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinksHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Links Hover Background Color :</Heading>
                <ColorPalette
                    value={megaMenuLinksHoverBGColor}
                    onChange={(colorValue) => setAttributes({ megaMenuLinksHoverBGColor: colorValue })}
                    clearable={false}
                />
                <Heading className={"frhd__pb-heading"}>Dropdown Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownColor}
                    onChange={(colorValue) =>
                    setAttributes({megaMenuDropdownColor: colorValue })
                    }
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Dropdown Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuDropdownHoverColor}
                    onChange={(colorValue) => setAttributes({megaMenuDropdownHoverColor: colorValue })}
                    clearable={false}
                />
                <Heading className={'frhd__pb-heading'}>Mega Menu Button Color :</Heading>
                <ColorPalette
                    value={megaMenuBtncolor}
                    onChange={(colorValue) => setAttributes({ megaMenuBtncolor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Button Hover Color :</Heading>
                <ColorPalette
                    value={megaMenuBtnHovercolor}
                    onChange={(colorValue) => setAttributes({megaMenuBtnHovercolor: colorValue })}
                    clearable={false}
                />
                    <Heading className={'frhd__pb-heading'}>Mega Menu Border Color :</Heading>
                <ColorPalette
                    value={megaMenuBorderColor}
                    onChange={(colorValue) => setAttributes({ megaMenuBorderColor: colorValue })}
                    clearable={false}
                />
            </PanelBody>
        </InspectorControls>,
        <div {...blockProps} key={`${id}-main-blocks`}>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} className={'hfc-mega-menu'}>
                <InnerBlocks
                    allowedBlocks={ALLOWED_BLOCKS}
                    template={TEMPLATE}
                    />
            </div>
        </div>
    ])
}

export const save = ({ attributes }) => {

    const {
        id,
        menuItemNum,
        megaMenuLinkSize,
        megaMenuInnerWidth,
        megaMenuBGcolor,
        megaMenuPadding,
        megaMenuLinkCurrentColor,
        megaMenuLinksHoverColor,
        megaMenuDropdownColor,
        megaMenuDropdownHoverColor,
        megaMenuBtncolor,
        megaMenuBtnHovercolor,
        megaMenuBorderColor,
        megaMenuLinksHoverBGColor,
        megaMenuCardImageHeight
    } = attributes;

    const hfcmmDynamicStyles = `#${id}.hfc-mega-menu {
        display: none;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        z-index: 0;
        top: 25px;
    }
    .hfc-main-header-2 #${id}.hfc-mega-menu{
        left: unset !important;
        transform: unset !important;
        right: 0;
        top: 50% !important;
    }
    #${id}.hfc-mega-menu .hfc-mm-1{
        background-color: ${megaMenuBGcolor};
        padding: ${megaMenuPadding}px;
        border-radius: 10px;
        box-shadow: 0px 13px 34px 0px rgba(0, 0, 0, 0.35);
        border-top: 5px solid ${megaMenuBorderColor};
        margin-top: 25px;
        width: ${megaMenuInnerWidth};
    }
    #${id} .hfc-main-header-3 .hfc-mm-1 .hfc-mm-col {
        display: flex;
        flex-direction: column;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label{
        position: relative;
        line-height: 30px;
        display: block;
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label::after{
        content: '';
        position: absolute;
        top: 10px;
        margin-left: 5px;
        box-sizing: border-box;
        height: 8px;
        width: 8px;
        border-style:solid;
        border-color:${megaMenuDropdownColor};
        border-width: 0px 2px 2px 0px;
        transform: rotate(45deg);
    }
    .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after,
    .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu .wp-block-navigation-item__label:hover::after{
        border-color: ${megaMenuDropdownHoverColor};
    }
    #${id} ul.hfc-mm-list li{
        font-size: ${megaMenuLinkSize};
    }
    #${id} ul.hfc-mm-list li a {
        padding: 10px calc(${megaMenuPadding}px - 10px);
        display: block;
        border-bottom: 1px dotted ${megaMenuBorderColor};
        padding-left: 0;
        transition: .3s;
        text-decoration: none!important;
        color: ${megaMenuLinkCurrentColor};
    }
    #${id} ul.hfc-mm-list li a:hover {
        background: ${megaMenuLinksHoverBGColor};
        padding-left: 10px;
        color: ${megaMenuLinksHoverColor};
        border: 0;
    }
    #${id} .hfc-mm-col .wp-block-image img {
        display: block;
        height: ${megaMenuCardImageHeight};
        object-fit: cover;
        margin-bottom: 4px;
    }
    #${id} .hfc-mm-col h4.wp-block-heading {
        font-size: 18px;
        font-weight: bold;
        margin-top: 0px;
        margin-bottom: 4px;
    }
    #${id} .hfc-mm-col p {
        font-size: 14px;
        margin-top: 0px;
        margin-bottom: 4px;
        line-height: 20px;
        color: #000!important;
        font-weight: normal;
    }
    #${id} .wp-block-columns.hfc-mm-cols {
        gap: 10px;
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col ul{
        list-style: none;
        margin: 0px;
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col .hfc-mm-col-link a{
        text-decoration: none;
        color: ${megaMenuBtncolor};
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col .hfc-mm-col-link a:hover{
        color: ${megaMenuBtnHovercolor};
    }
    #${id} .wp-block-columns.hfc-mm-cols .hfc-mm-col:first-child {
        padding-right: ${megaMenuPadding}px;
    }
    #${id} .wp-block-columns.hfc-mm-cols .wp-block-column.hfc-mm-col:not(:first-of-type) {
        border: 1px solid ${megaMenuBorderColor};
        padding: 5px;
    }
    @media (max-width: 599px){
        .hfc-col-header-1 .wp-block-navigation-item.has-mega-menu a::after,
        .hfc-col-header-2 .wp-block-navigation-item.has-mega-menu a::after,
        .hfc-col-header-3 .wp-block-navigation-item.has-mega-menu a::after{
            display: none;
        }
    }`;

    return (
        <>
            <RawHTML>{`<style>${hfcmmDynamicStyles}</style>`}</RawHTML>
            <div id={id} data-menu-item-number={menuItemNum} className={'hfc-mega-menu'}>
                <InnerBlocks.Content />
            </div>
        </>
    )
}